import React, { useContext } from 'react';
import "./HowItWorksV2.scss";
import { fetchSubscriptionAmount, fetchSubscriptionCurrency, getCurrencySymbol, makeOnDemandSubs } from '../../../services/helperFunctions';
import { useParams } from 'react-router-dom';
import { UserLoginContext } from '../../../contexts/LoggedInUserContext';

const steps = [
    {
        title: 'Today',
        description: 'Start your SIP with minimum',
        cta: 'JOIN NOW',
        highlight: true,
    },
    {
        title: 'Day 25',
        description: 'choose the fundraiser you want to support',
    },
    {
        title: 'Day 30',
        description: 'Money deducted goes to the chosen fundraiser',
    },
    {
        title: 'Next steps',
        description: "Receive updates about the SIP Impact you've created",
    },
];

const HowItWorksV2 = () => {
    const { cause_name } = useParams();
    const { userData, latestOrder } = useContext(UserLoginContext);
    const firstAmount = fetchSubscriptionAmount(latestOrder?.ondemandSubscription, userData?.latest_subscription?.currency);
    const currency = fetchSubscriptionCurrency(latestOrder, userData);

    const handleSubscribeSIP = () => {
        let multiCauses = [cause_name];
        const sipParams = multiCauses.map((value) => `sip_cause=${value}`).join('&');
        makeOnDemandSubs(userData.id, multiCauses, firstAmount, currency.toLowerCase(), latestOrder?.ondemandSubscription?.id, sipParams)
    }
    return (
        <>
            <div className="sip-container">
                <p className="sip-title">How It Works?</p>
                <div className="sip-steps">
                    {steps.map((step, index) => (
                        <div key={index} className={`sip-step ${index === 3 && cause_name !== "medical" ? "hide" : ""}`}>
                            <div className={index !== 0 ? "sip-dot-small" : "sip-dot"} >
                                {index == 0 && <div className="active_sip-dot" />}
                                {index == 0 && <div className="active_sip-line" />}
                            </div>
                            <div className="sip-line" />
                            <div className="sip-content">
                                <p className='title'>{step.title}</p>
                                <p className='sub-title'>{`${step.description} ${index === 0 ? `${getCurrencySymbol(currency)}${firstAmount}/month` : ""}`}</p>
                                {step.cta && <span className="sip-cta" onClick={handleSubscribeSIP}>{step.cta}</span>}
                            </div>
                        </div>
                    ))}
                </div>
                <div className="sip-footer">
                    Pause or cancel subscription anytime
                </div>
            </div>
        </>
    )
}

export default HowItWorksV2;